import { render, staticRenderFns } from "./user-blacklist.vue?vue&type=template&id=07536522&scoped=true"
import script from "./user-blacklist.vue?vue&type=script&lang=js"
export * from "./user-blacklist.vue?vue&type=script&lang=js"
import style0 from "./user-blacklist.vue?vue&type=style&index=0&id=07536522&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07536522",
  null
  
)

export default component.exports